<template>
  <div class="container page">
    <AppToolbar
      :title="item.name ? item.name : $t('message.new_vessel')"
      :prev-route="{
        name: 'OrganizationShow',
        params: { id: $route.params.organization_id }
      }"
    >
    </AppToolbar>

    <template v-if="error">
      <GenericError />
    </template>

    <template v-else>
      <div v-if="isLoading" class="content-spinner">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </div>
      <VesselForm
        v-else-if="organization"
        ref="form"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :initial-values="item"
        :errors="violations"
      />

      <v-btn color="warning" fab fixed bottom right @click="save">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VesselForm from './Form'
import AppToolbar from '@/components/AppToolbar'
import GenericError from '@/components/error/GenericError'

export default {
  components: {
    VesselForm,
    AppToolbar,
    GenericError
  },

  data() {
    return {
      item: {},
      errorDialog: false
    }
  },

  computed: {
    ...mapGetters({
      organization: 'organization/show/retrieved',
      error: 'vessel/create/error',
      isLoading: 'vessel/create/isLoading',
      created: 'vessel/create/created',
      violations: 'vessel/create/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return
      }

      this.$router.push({
        name: 'OrganizationShow',
        params: { id: this.$route.params.organization_id }
      })
    },

    organization: function(organization) {
      if (!organization) {
        return
      }

      this.item.organization = organization
    }

    /*error: function (error) {
        if (!error) {
          return
        }

        this.errorDialog = true
      }*/
  },

  created() {
    this.getOrganization(this.$route.params.organization_id)
  },

  methods: {
    ...mapActions({
      getOrganization: 'organization/show/retrieve',
      create: 'vessel/create/create'
    }),

    save() {
      this.$refs.form.onSubmit(this.item)
    },

    onSendForm() {
      this.create(this.item)
    },

    updateField() {}
  }
}
</script>
